module.exports = __webpack_public_path__ + "img/Path 743.82eb154a.svg";